import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NetworkType } from '../model/gym';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  private networkSubject = new BehaviorSubject<NetworkType | null>(null);
  network$ = this.networkSubject.asObservable();

  setNetwork(network: NetworkType | null): void {
    this.networkSubject.next(network);
  }
}
